<template>
  <div class="search-geonames">

    <f7-list>
      <f7-list-input
        ref="input"
        type="text"
        clear-button
        :placeholder="t('searchPh')"
        @input.native="input"
        @input:clear="clear"
        @input="debounceSearch">
        <span slot="media">
          <f7-preloader v-if="loading" />
          <FlatIcon
            v-else
            :size="20"
            name="search" />
        </span>
      </f7-list-input>
    </f7-list>

    <f7-list
      v-if="resultsDistance.length">
      <f7-list-item
        v-for="(res, i) in resultsDistance"
        :key="i"
        :class="{ 'item-link' : !res.dist }"
        @click="click(res)">
        <span slot="title">
          <FlagIcon
            v-if="res.flag"
            rounded
            :size="15"
            :code="res.flag" />
          {{ res.name }}
        </span>
        <DistanceUnit
          v-if="res.dist"
          slot="after"
          best
          :value="res.dist" />
        <span slot="footer">
          {{ res.place }}
          <span v-if="res.place ">, </span>
          {{ res.country }}
        </span>
      </f7-list-item>
    </f7-list>
    <p
      v-if="!loading && term && !results.length"
      class="text-align-center">
      {{ t('noResult') }}
    </p>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { mapGetters } from 'vuex'
import { getLocations } from '@/services/geonames'

export default {
  name: 'SearchGeonames',
  data () {
    return {
      term: '',
      loading: false,
      results: []
    }
  },
  computed: {
    ...mapGetters({
      lang: 'global/lang',
      geoPos: 'global/geoPos',
      geoActive: 'global/geoActive'
    }),
    resultsDistance () {
      if (this.geoPos && this.geoActive) {
        const pos = this.$turf.point([this.geoPos[1], this.geoPos[0]])
        return this.results.map(r => {
          const geo = this.$turf.point([r.coords[1], r.coords[0]])
          r.dist = this.$turf.distance(pos, geo, { units: 'kilometers' }) * 1000
          return r
        })
      } else {
        return this.results
      }
    }
  },
  methods: {
    input (e) {
      const term = e.target.value
      if (term) this.loading = true
      else {
        this.loading = false
        this.results = []
      }
      this.$emit('change', term)
    },
    search (term) {
      this.loading = true
      getLocations(term, this.lang).then(res => {
        this.results = res
      }).finally(() => {
        this.loading = false
      })
    },
    debounceSearch: debounce(function (e) {
      this.term = e.target.value
      if (this.term) this.search(this.term)
      else this.results = []
    }, 800),
    clear () {
      this.term = ''
      this.loading = false
      this.resuls = []
    },
    click (item) {
      this.$emit('click', item.coords)
    },
    focus () {
      const el = this.$refs.input.$el
      const input = el.getElementsByTagName('INPUT')[0]
      input.focus()
    }
  }
}
</script>
